import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import initWebVitals from "./components/performance/WebVitalsReporter";
import { performanceTracker } from "./components/performance/PerformanceTracker";
import { captureException, logger } from "./utils/logger";

// Инициализация Sentry для production
if (
  process.env["NODE_ENV"] === "production" &&
  process.env["REACT_APP_SENTRY_DSN"]
) {
  Sentry.init({
    dsn: process.env["REACT_APP_SENTRY_DSN"],
    environment: process.env["NODE_ENV"],
    release: process.env["REACT_APP_VERSION"] || "1.0.0",

    // Интеграции
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    // Performance Monitoring
    tracesSampleRate: 0.1, // 10% транзакций

    // Session Replay (только для ошибок)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0, // 100% replay при ошибках

    // Фильтрация
    beforeSend(event: Sentry.ErrorEvent, _hint: Sentry.EventHint) {
      // Не отправлять в dev
      if (process.env["NODE_ENV"] !== "production") {
        return null;
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (
  process.env["NODE_ENV"] !== "production" ||
  process.env["REACT_APP_ENABLE_WEB_VITALS"] === "true"
) {
  initWebVitals((metric) => {
    performanceTracker.mark(metric.name);
    if (Number(process.env["REACT_APP_LOG_WEB_VITALS"]) === 1) {
      logger.info("[WebVitals]", metric.name, metric.value, metric);
    }
  });
}

// Глобальные перехватчики ошибок
window.addEventListener("error", (event) => {
  captureException(event.error || event.message, {
    source: "window",
    type: "error",
  });
});

window.addEventListener("unhandledrejection", (event) => {
  captureException(event.reason, {
    source: "window",
    type: "unhandledrejection",
  });
});
